import { preconnect, prefetchDNS } from "react-dom"

const SESSION_HINT_COOKIE = "entire_website_session_hint"
const DASHBOARD_PATH = "/home"
const GITHUB_ORIGIN = "https://github.com"

function findLink(rel: string, href: string): HTMLLinkElement | null {
  if (typeof document === "undefined") return null

  for (const link of document.head.querySelectorAll<HTMLLinkElement>("link")) {
    if (link.getAttribute("rel") === rel && link.getAttribute("href") === href) {
      return link
    }
  }

  return null
}

function ensureLink(rel: string, href: string, attributes: Record<string, string> = {}) {
  if (typeof document === "undefined") return null

  const existing = findLink(rel, href)
  if (existing) return existing

  const link = document.createElement("link")
  link.rel = rel
  link.href = href

  for (const [name, value] of Object.entries(attributes)) {
    link.setAttribute(name, value)
  }

  document.head.appendChild(link)
  return link
}

function readSessionHintFromCookie(): string | null {
  if (typeof document === "undefined") return null

  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${SESSION_HINT_COOKIE}=([^;]+)`))
  return match?.[1] ?? null
}

export function hasWebsiteSessionHint(): boolean {
  if (typeof document === "undefined") return false

  const sessionState = document.documentElement.dataset["hasSession"]
  if (sessionState === "true") return true
  if (sessionState === "false") return false

  return readSessionHintFromCookie() === "true"
}

export function warmSignInIntent() {
  preconnect(GITHUB_ORIGIN)
  prefetchDNS(GITHUB_ORIGIN)
}

export function warmDashboardIntent() {
  if (!hasWebsiteSessionHint()) return
  ensureLink("prefetch", DASHBOARD_PATH)
}
